var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIconGreen2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phone-icon--green-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MacBook-Pro-14\"-Copy",
    transform: "translate(-555, -514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone-icon--green-2",
    transform: "translate(555, 514)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#EDEDED",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-phone-1147912",
    transform: "translate(11, 11)",
    fill: "#82BC00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9757517,19.4372231 L18.0964955,16.9233512 C17.4112067,16.5681302 16.5614486,16.7594031 16.0954522,17.3605463 L14.3137014,19.6558207 C12.559362,18.7267811 11.2436076,17.8250662 9.70856066,16.2948833 C8.06386756,14.6554016 7.1866979,13.3164916 6.30952825,11.6223605 L8.58468704,9.84625534 C9.18774118,9.38173554 9.37962204,8.53467 9.02327187,7.85155264 L6.50140911,3.01508171 C6.06282428,2.16801618 4.96636221,1.89476923 4.17142721,2.41393843 L1.07392186,4.49061521 C0.361221514,4.98245971 -0.0499517622,5.80220055 0.00487134136,6.64926608 C0.0596944449,7.52365631 0.169340652,8.64396878 0.388633066,9.40906023 C1.29321427,12.8792964 3.45872686,16.4588314 6.52882066,19.4918725 C9.5715029,22.5249136 13.1624162,24.6835645 16.6436833,25.6126041 C17.4112067,25.803877 18.5350803,25.9131757 19.4396615,25.9951498 C20.3168312,26.0497992 21.1665893,25.6399288 21.6325857,24.902162 L23.6610405,21.7598222 C24.0996253,20.9400813 23.7980983,19.8744182 22.9757517,19.4372231 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1075931,10.2014764 C13.7106472,10.3654245 14.3137014,10.6933209 14.7796977,11.1851654 C15.2731057,11.6770099 15.6020443,12.2508285 15.7665136,12.8519717 C15.9035714,13.3438162 16.3695677,13.6717126 16.8903872,13.6443879 L17.0000334,13.6443879 C17.7127338,13.6170632 18.2335533,12.9339458 18.0416724,12.2508285 C17.7675569,11.2671395 17.2467374,10.3107751 16.4518024,9.5456837 C15.6568674,8.75326756 14.7248746,8.23409836 13.7380588,7.96085142 C13.05277,7.76957856 12.3674812,8.28874775 12.3400696,8.99918981 L12.3400696,9.10848859 C12.2852465,9.60033309 12.6141851,10.0648529 13.1075931,10.2014764 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4365317,6.26672036 C14.944167,6.5399673 16.3969793,7.25040936 17.5482645,8.39804653 C18.7269612,9.5730084 19.4396615,10.9938925 19.6863655,12.4967507 C19.7960117,13.0432446 20.2894196,13.453115 20.8650622,13.4257903 L20.9472969,13.4257903 C21.6325857,13.3984656 22.1259936,12.7699977 21.9889359,12.114205 C21.6325857,10.146827 20.7005929,8.26142306 19.1929576,6.73124016 C17.6579107,5.20105727 15.7939252,4.27201766 13.7928819,3.94412132 C13.1350046,3.83482254 12.5045389,4.32666704 12.4771274,4.98245971 L12.4771274,5.0644338 C12.4771274,5.66557708 12.8883007,6.15742158 13.4365317,6.26672036 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9910224,11.9502568 C25.5798491,9.02651451 24.2640946,6.21207097 22.0163474,3.97144602 C19.7686002,1.73082106 16.9452103,0.419235724 14.0121743,0.00936530616 C13.354297,-0.0726087775 12.7512429,0.39191103 12.7238314,1.07502839 L12.7238314,1.18432717 C12.6964198,1.78547045 13.1350046,2.27731495 13.7106472,2.35928904 C16.1502753,2.68718537 18.4802572,3.80749785 20.3442427,5.66557708 C22.2082283,7.52365631 23.3046903,9.87358004 23.6610405,12.2781532 C23.7432752,12.8519717 24.2366831,13.2891669 24.8397372,13.2618422 L24.9493834,13.2618422 C25.5798491,13.2071928 26.0732571,12.6060495 25.9910224,11.9502568 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconGreen2);
export default __webpack_public_path__ + "static/media/phone-icon--green-2.517413e3bb0951fdaae49fd60466c49c.svg";
export { ForwardRef as ReactComponent };